import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const KEY = "ccc_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          slug: product.slug,
          price: product.price,
          image: (product.images || [])[0] || "",
          quantity,
        },
      ];
    });
  };

  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));

  const setQty = (product_id, quantity) =>
    setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i)));

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
